// https://pt.stackoverflow.com/questions/179100/como-fazer-para-que-o-local-storage-expire
function localStorageExpires(){for(var e=[],a=(new Date).getTime(),o=0,r=localStorage.length;o<r;o++){var t=localStorage.getItem(localStorage.key(o));t&&/^\{(.*?)\}$/.test(t)&&(t=JSON.parse(t)).expires&&t.expires<=a&&e.push(localStorage.key(o))}for(o=e.length-1;0<=o;o--)localStorage.removeItem(e[o])}localStorageExpires();
localStorageExpires();//Auto executa a limpeza
function setLocalStorage(e,t,a){var i=(new Date).getTime()+6e4*a;localStorage.setItem(e,JSON.stringify({value:t,expires:i}))}
function getLocalStorage(a) {localStorageExpires();var e = localStorage[a];if (!(!e || !/^\{(.*?)\}$/.test(e))) {return JSON.parse(e).value}return null;}

window.SELLER_DEFAULT = 'fabricadeimas';

$(document).ready(function () {

	/* ATIVAÇÃO DO MEGAMENUMOBILE */
	$.megaMenu();

	$.carregarUsuarioLogado();

	$(document).ajaxStop(function () {
		/* CONTROLA EXIBIÇÃO DO MINICART */
		$.minicartVisible();
	});

	// NEWSLETTER
	$.cadastrarNewsletter();

	/* ALTERAÇÃO DO BOTAO BUSCAR PARA PESQUISAR */
	$('.btn-buscar').val(' ');

	/* ALTERAÇÃO DO TEXTO DO CARRINHO NO HEADER */
	$('#MostraTextoXml3').text('Meu Carrinho');

	/* INCLUSÃO DAS FLAGS NA PRATELEIRA */
	//$( ".collection-image-link" ).after( $( '<div class="flag-prateleira-destaque"><p>Desconto</p></div>' ) );
	//$( ".price" ).after( $( '<div class="flag-prateleira-destaque-bottom"><p>Desconto</p></div>' ) );

	/* ADICIONA O TEXTO NAS INPUTS DE PRODUTO ESGOTADO */
	$(".sku-notifyme-client-name.notifyme-client-name").attr("placeholder", "Nome");
	$(".sku-notifyme-client-email.notifyme-client-email").attr("placeholder", "E-mail");

	// Torna clicável o carrinho
	$('.portal-totalizers-ref').click(function () {
		window.location.href = '/checkout/#/cart';
	});

	$.verificarFlagPagueMenos();

	$.verificarQuantidadeFlagsPrateleira();

	/*if($('body').hasClass('rnk-home')) {
		$.aplicarLids('home');
	}*/

	if ($('body').hasClass('rnk-categoria')) {
		$(".search-multiple-navigator input[type='checkbox']").vtexSmartResearch({
			shelfCallback: function () {
				console.log('shelfCallback');

				setTimeout(function () {
					$.executarFuncoesCard();
					$.verificarFlagPagueMenos();
					$.verificarQuantidadeFlagsPrateleira();
				}, 900)
			},
			ajaxCallback: function () {
				console.log('ajaxCallback');

				setTimeout(function () {
					$.executarFuncoesCard();
					$.verificarFlagPagueMenos();
					$.verificarQuantidadeFlagsPrateleira();
				}, 900)
			}
		});
	}

	if ($('body').hasClass('rnk-departamento')) {
		$.lerMaisDpto();
	}

	if ($('body').hasClass('rnk-departamento') || $('body').hasClass('rnk-categoria') || $('body').hasClass('rnk-resultado-de-busca')) {
		$.executarFuncoesCard();
		$.filtroLateral();
	}

	if ($('body').hasClass('rnk-produto')) {
		/* ALTERAÇÃO DO TEXTO DO BOTÃO ADICIONAR AO CARRINHO DA PAGINA CATEGORIA */
		$('.buy-button-normal').text('Adicionar ao carrinho');

		/* ALTERAÇÃO DO TEXTO DO BOTÃO ADICIONAR AO CARRINHO DA PAGINA PRODUTO  */
		$('.buy-in-page-button').text('Adicionar ao carrinho');

		/* ALTERAÇÃO DO TEXTO DO BOTÃO PRODUTO ESGOTADO */
		$('.out-of-stock').text('Avise-me');

		/* ALTERAÇÂO DO TEXTO DE PRODUTO ESGOTADO */
		$('.notifymetitle.notifyme-title').text('Produto Esgotado. Avise-Me quando Chegar !');

		$.aplicarEtiquetasProduto();
	}
});

$.trocaValorParcelamentoProgressivo = function () {
	let novoValorPor = $('.plugin-preco .productPrice .descricao-preco .novo-valor-por strong')
	let valorFormatado = novoValorPor.text().replace('R$ ', '').replace('.', '').replace(',', '.')
	let tagValorDividido = $('.plugin-preco .productPrice .descricao-preco .novo-valor-dividido')
	let descontoAtual;
	let parcela;

	for (let parcelas = 1; parcelas < 6; parcelas++) {
		if (parseFloat(valorFormatado / parcelas).toFixed(2) >= 10) {
			descontoAtual = parseFloat(valorFormatado / parcelas).toFixed(2)
			parcela = parcelas;
		} else {
			break;
		}
	}

	$(tagValorDividido).html('<span>Até ' + parcela + 'x de R$ ' + descontoAtual.replace('.', ',') + ' sem juros</span>')
}

$.carregarUsuarioLogado = function () {
	$.getJSON('/no-cache/profileSystem/getProfile', function (response) {
		if (response != null) {
			var identificacaoUsuario = '';

			if (response.FirstName != null && response.FirstName != '') {
				identificacaoUsuario = response.FirstName;
			} else if (response.Email != null && response.Email != '' && response.Email.indexOf('@') > -1) {
				identificacaoUsuario = response.Email.split('@')[0];
			}

			// HTML do dropdown
			var dropAccount = '';

			if ($(window).width() < 1025) {
				dropAccount += '	<div class="drop-account active">';
			} else {
				dropAccount += '	<div class="drop-account">';
			}
			dropAccount += '		<ul class="drop-account-list">';
			dropAccount += '			<li><a href="/_secure/account" alt="Meus Dados">Meus Dados</a></li>';
			dropAccount += '			<li><a href="/_secure/account#/orders" alt="Meus Pedidos">Meus Pedidos</a></li>';
			dropAccount += '			<li><a href="/no-cache/user/logout" alt="Sair">Sair</a></li>';
			dropAccount += '		</ul>';
			dropAccount += '</div>';

			// Faz a inclusão do drop html
			if ($(window).width() < 1025) {
				// Mobile
				if (identificacaoUsuario != null && identificacaoUsuario != '') {
					$('.container-minha-conta-mobile a.nav-link').attr('href', 'javascript:void(0)');
					$('.container-minha-conta-mobile a.nav-link span:not(.rnk-fa-wrap)').html('Olá, ' + identificacaoUsuario);

					$('.container-minha-conta-mobile').append(dropAccount);

				}

			} else {
				// Desktop
				if (identificacaoUsuario != null && identificacaoUsuario != '') {
					$('.pre-header li.sprite-login').html('Olá, ' + identificacaoUsuario);
					$('.pre-header li.sprite-login').append(dropAccount);

				}

			}

		}
	});
}

$.executarFuncoesCard = function () {
	$('.flag-prateleira-destaque, .flag-prateleira-destaque-bottom').remove();

	// $(".collection-image-link").after($('<div class="flag-prateleira-destaque"><p>Desconto</p></div>'));
	// $(".price").after($('<div class="flag-prateleira-destaque-bottom"><p>Desconto</p></div>'));

	$("li.helperComplement").remove();

	$('.buy-button-normal').text('Adicionar ao carrinho');


	/*$.aplicarLids($('body').hasClass('rnk-departamento') ? 'departamento' : 'categoria');*/
}

$.megaMenu = (function () {
	if ($(window).width() < 992) {

		// Toggle Overlay open
		$('#navbarsExample04').on('show.bs.collapse', function () {
			$('.rnk-megamenu-overlay').fadeIn();
		});
		// Toggle Overlay close
		$('#navbarsExample04').on('hide.bs.collapse', function () {
			$('.rnk-megamenu-overlay').fadeOut();
		});

		// Abre o segundo nível do menu
		$('.nav-item.rnk-dropdown.menu-area .nav-link').click(function (e) {
			e.preventDefault();
			$(this).next().addClass('active');
		});

		// Fecha o segundo nível do menu
		$('.rnk-menu-link-back').click(function (e) {
			e.preventDefault();
			$('.rnk-dropdown-menu.mega-area').removeClass('active');
		});

		// Fecha o segundo nível do menu depois o principal
		$('.rnk-megamenu-overlay').click(function (e) {
			e.preventDefault();
			if ($('.rnk-dropdown-menu.mega-area.active').length > 0) {
				$('.rnk-dropdown-menu.mega-area').removeClass('active');
			} else {
				$('.navbar-toggler').click();
			}

		});

		// Fecha o segundo nível do menu depois o principal
		$('.rnk-megamenu-overlay > .rnk-close').click(function (e) {
			e.preventDefault();
			if ($('.rnk-dropdown-menu.mega-area.active').length > 0) {
				$('.rnk-dropdown-menu.mega-area').removeClass('active');
			} else {
				$('.navbar-toggler').click();
			}

		});

	}
});

$.minicartVisible = (function () {
	var items = parseInt($('.new-amount-items-em').text()),
		alvo = $('.container-popover-carrinho');

	if (items === 0) {
		alvo.hide()
	}
});

$.filtroLateral = (function () {
	$('.sidebar-categoria').prepend('<button class="rnk-close"><i class="fas fa-times"></i></button>');
	$('.mobile-filter .btn-filtro').click(function (e) {
		e.preventDefault();
		$('.sidebar-categoria').addClass('active');
	});
	$('.sidebar-categoria .rnk-close').click(function (e) {
		e.preventDefault();
		$('.sidebar-categoria').removeClass('active');
	});
});

$.lerMaisDpto = (function () {

	$('.departamento-destaque-titulo-leia-mais').next('a').click(function (e) {

		e.preventDefault();
		$(this).prev().toggle('active');

	});

});

$.atualizaCarrinho = (function () {
	const fn = orderForm => {
		var htmlCarrinho = '';
		$(orderForm.items).each(function (i, item) {
			htmlCarrinho += '<tr>';
			htmlCarrinho += '	<th><img src="' + item.imageUrl + '"></th>';
			htmlCarrinho += '	<th>' + item.name + '</th>';
			htmlCarrinho += '	<td>' + item.quantity + ' und.</td>';
			htmlCarrinho += '	<td>' + $.maskMoney(parseFloat((item.sellingPrice / 100) * item.quantity).toFixed(2)) + '</td>';
			htmlCarrinho += '</tr>';
		});

		$('.container-popover-carrinho .tabela-itens-carrinho-popover tbody').html(htmlCarrinho);

		var valorTotalCarrinho = 0;

		$.each(orderForm.totalizers, function (i, totalizer) {
			valorTotalCarrinho += totalizer.value;
		});

		// Exibe o valor total do carrinho
		$('.container-popover-carrinho .tabela-itens-carrinho-popover .valor-total-carrinho').html('R$ ' + $.maskMoney(parseFloat(valorTotalCarrinho / 100).toFixed(2)));

		// Exibe a quantidade de itens no carrinho
		setTimeout(function () {
			$('.portal-totalizers-ref .amount-items-in-cart .amount-items').append('<em class="new-amount-items-em">' + orderForm.items.length + '</em>');
		}, 500);
	}
	if (window?.vtexjs?.checkout?.orderForm) {
		return fn(window.vtexjs.checkout.orderForm);
	}

	vtexjs.checkout.getOrderForm().done(fn)
});

$(window).on('orderFormUpdated.vtex', $.atualizaCarrinho)

$.aplicarEtiquetasProduto = (function () {
	$('.lista-etiquetas-beneficios-e-descontos').html('');

	$('.flags p.flag').each(function (i, flag) {
		if ($(flag).hasClass('levemaispaguemenos')) {
			$('.produto-leve-mais-pague-menos').show();
		}

		if ($(flag).hasClass('boleto-10--de-desconto')) {
			$('.lista-etiquetas-beneficios-e-descontos').append('<li class="etiqueta-desconto">10% off</li>');
		}
	});

	//<ul class="lista-etiquetas-beneficios-e-descontos"><li class="etiqueta-novo">Novo</li><li class="etiqueta-frete-gratis">Frete grátis</li><li class="etiqueta-super-forte">Super forte</li><li class="etiqueta-melhor-compra">Melhor compra</li><li class="etiqueta-desconto">10% off</li></ul>
});


//////////////////
// UTILITARIOS //
////////////////

/*$.aplicarLids = (function(pagina) {
	if(pagina == 'home') {
		$('.bg-destaque').each(function(i, destaque) {
			$(this).parent().attr('href', $(this).parent().attr('href') + '?lid=b3862de3-1e60-4c76-a279-f8109f0c1d1a');
		});
		
		$('.conjunto-imas').each(function(i, destaque) {
			$(this).find('a').attr('href', $(this).find('a').attr('href') + '?lid=b3862de3-1e60-4c76-a279-f8109f0c1d1a');
		});
	}
	
	if(pagina == 'departamento') {
		$('.prateleira.vitrine').each(function(i, link) {
			$(this).next().attr('href', $(this).next().attr('href') + '?lid=0e758f13-034b-4582-9750-16c6cbdee0d7');
		});
		
	}
	
	if(pagina == 'categoria') {
		$('.prateleira.vitrine a').each(function(i, link) {
			$(this).attr('href', $(this).attr('href') + '?lid=3485be94-bb68-418c-8ad2-f70fecc839b3');
		});
	}
});*/

$.maskMoney = (function (x) {
	var parts = x.toString().split(".");
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	return 'R$ ' + parts.join(",");
});

$.unmaskMoney = (function (value) {
	return value === undefined || value == null || value == 0 ? '' : parseFloat(value.replace('R$ ', '').replace('.', '').replace(',', '.'));
});

$.cadastrarNewsletter = function () {
	$('.rnk-componente-captura-de-lead form').submit(function (e) {
		e.preventDefault();

		let inputEmailNewsletter = $(this).find('input.form-control');
		let inputEmailNewsletterPlaceholder = $(inputEmailNewsletter).attr('placeholder');

		$.ajax({
			type: 'PATCH',
			async: !0,
			url: '/api/dataentities/NL/documents',
			data: JSON.stringify({ email: $(inputEmailNewsletter).val() }),
			contentType: 'application/json'
		}).done(function (response) {
			console.log("Email cadastrado: " + response.DocumentId);

			$(inputEmailNewsletter).val('');
			$(inputEmailNewsletter).attr('placeholder', 'Email cadastrado com sucesso!');

			setTimeout(function () {
				$(inputEmailNewsletter).attr('placeholder', inputEmailNewsletterPlaceholder);
			}, 3000);

		}).fail(function (result) {
			console.log("Erro ao Cadastrar Email: " + result.responseText);

			$(inputEmailNewsletter).val('');
			$(inputEmailNewsletter).attr('placeholder', 'Sistema indisponível!');
		});
	});
}

$.verificarFlagPagueMenos = (function () {
	$('.flag-levemaispaguemenos').remove()
	
	if ($('body').hasClass('rnk-categoria') ||
		$('body').hasClass('rnk-departamento')) {
		$('.prateleira ul li').each(function() {
			let _alvo = $(this);
			if($(this).find('.flag-collection > p.levemaispaguemenos').is(':visible')) {
				$(_alvo).find('.collection-link').after($('<div class="flag-levemaispaguemenos"><p>Leve <i class="far fa-plus-circle"></i><span>+</span> pague <i class="far fa-minus-circle"></i><span>-</span></p></div>'))
			}
		})
	} 

	if($('body').hasClass('rnk-produto')) {
		if ($('.flag-collection > p.levemaispaguemenos').is(":visible")) {
			$(".container-section-flag-discount").prepend('<div class="flag-levemaispaguemenos"><p>Leve <i class="far fa-plus-circle"></i><span>+</span> pague <i class="far fa-minus-circle"></i><span>-</span></p></div>');
		}
	}
});

$.verificarQuantidadeFlagsPrateleira = (function () {
	if ($('body').hasClass('rnk-departamento') || $('body').hasClass('rnk-categoria') || $('body').hasClass('rnk-home')) {
		$('.prateleira ul li').each(function (i, itemPrateleira) {
			let quantidadeFlags = 0;

			$($(this).find('.flags .flag')).each(function (j, itemPrateleiraFlag) {
				if (!$(itemPrateleiraFlag).hasClass('levemaispaguemenos')) {
					quantidadeFlags++;
				}

				if (quantidadeFlags > 2) {
					$(itemPrateleiraFlag).addClass('d-none');
				}
			});
		});

	} if ($('body').hasClass('rnk-produto')) {
		let quantidadeFlags = 0;

		$('.container:not(.container-aproveite-e-veja-tambem) .flags .flag').each(function (j, itemPrateleiraFlag) {
			if (!$(itemPrateleiraFlag).hasClass('levemaispaguemenos')) {
				quantidadeFlags++;
			}

			if (quantidadeFlags > 2) {
				$(itemPrateleiraFlag).addClass('d-none');
			}
		});
	}
});

$.ajustarParcelasDescontoProgressivo = (function () {
	let valorMinimoParcela = 10;
	$('.tabela-unidade-desconto .linha-destaque').click(function () {
		let novoValorTotal = $("novo-valor-por price-best-price").val;
		let novoValorParcelado = novoValorTotal / 5;
		$('.skuBestInstallmentValue').replace(novoValorParcelado);

	});
});

// REMOVENDO CATEGORIA/DEPARTAMENTE RESULTADO DE BUSCA NO HEADER //

$.ajaxSetup({

    dataFilter: function (response, type) {

        if (response && response.indexOf('itemsReturned') > -1 && response.indexOf('criteria') > -1) {

            try {

                var data = JSON.parse(response);

                data.itemsReturned = data.itemsReturned.filter(function(item) { return !!item.items.length });

                return JSON.stringify(data);

            } catch (e) {}

        }

        return response;

    }

});